<template>
    <div class="KM-table">
        <el-table
            ref='tableListRef'
            :key="itemKey"
            :data='tableList'
            :header-cell-style="{background:'#409EFF',color:'#fff'}"
            size='mini'
            row-key="id"
            border
            default-expand-all
            @sort-change="sort_change"
            style="width: 100%">
            <el-table-column
                label="NO"
                sortable
                align="center"
                prop="num"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="variable"
                sortable
                label="名称">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                prop="intvalue"
                label="频次">
            </el-table-column>
        </el-table>
        <el-pagination 
            size='small'
            class="page-wrap"  
            @current-change="changePage" 
            @size-change="sizeChange"
            background
            :current-page="pageInfo.pageNum" 
            :page-count="pageInfo.pageTotal" 
            :page-size="pageInfo.pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="pageInfo.total"
            layout="total, sizes, prev, pager, next, jumper" >
        </el-pagination>
    </div>
</template>

<script>

import subjectJson from '../subjectJson.js'
import { mapState,mapMutations } from 'vuex'
export default {
    data () {
        return {
            column:{},
            itemKey:Math.random(),
            tableList:[],
            table:subjectJson.cfyy.jl_table,
            // KM_table:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
        }
    },
    computed: {  
    }, 
    created(){
        this.table.forEach((item,index) => {
            item.num=index+1;
        });
    },
    mounted() {

       this.changePage(1)
    },
    methods: {
        // 恢复默认排序
        clearSort(){
            this.$refs.tableListRef.clearSort();
        },
        changePage(num) {
            this.pageInfo.pageNum=num;
            this.pageInfo.total = this.table.length
            this.tableList= this.table.slice((this.pageInfo.pageNum-1)*this.pageInfo.pageSize,this.pageInfo.pageNum*this.pageInfo.pageSize);
 
            // }
        },
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column;
            // sizeChange
            this.pageInfo.total = this.table.length
            this.table = this.table.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        // 每页条数
        sizeChange(val) {
            this.pageInfo={
                pageSize:val,
                total:this.pageInfo.total,
                pageTotal:Math.ceil(this.pageInfo.total/val),
                pageNum:this.pageInfo.pageNum,
            }
            this.changePage(1)
            this.pageInfo.pageSize=val;
        },

    }
}
</script>

<style>

</style>